import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export default function ThesmikoPlaisio() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        mb: 1,
        mt: 1,
      }}
    >
      <Typography variant="h2" gutterBottom>
        Θεσμικό και Κανονιστικό Πλαίσιο του Μητρώου Απασχολούμενων στον
        Πολιτισμό
      </Typography>

      <Typography variant="body1" gutterBottom textAlign={'justify'}>
        1. <span style={{ textDecoration: 'underline' }}>Νόμος</span>: N.
        5039/2023 – Μέρος ΣΤ – ΚΕΦΑΛΑΙΟ Α «ΜΗΤΡΩΟ ΑΠΑΣΧΟΛΟΥΜΕΝΩΝ ΣΤΟΝ
        ΠΟΛΙΤΙΣΤΙΚΟ ΚΑΙ ΔΗΜΙΟΥΡΓΙΚΟ ΤΟΜΕΑ»,{' '}
        <Typography
          component={Link}
          color={'link.main'}
          target="_blank"
          to={'https://search.et.gr/el/fek/?fekId=612269'}
        >
          Α 83/2023
        </Typography>
      </Typography>

      <Typography variant="body1" gutterBottom textAlign={'justify'}>
        2.{' '}
        <span style={{ textDecoration: 'underline' }}>
          Κοινές Υπουργικές Αποφάσεις
        </span>
        : Καθορισμός των Κωδικών Αριθμών Δραστηριοτήτων (ΚΑΔ) και των κωδικών
        ειδικότητας, στους οποίους εμπίπτουν οι δραστηριότητες του πολιτιστικού
        και δημιουργικού τομέα{' '}
        <Typography
          component={Link}
          color={'link.main'}
          target="_blank"
          to={'https://search.et.gr/el/fek/?fekId=557269'}
        >
          Β 2905/2023
        </Typography>{' '}
        και{' '}
        <Typography
          component={Link}
          color={'link.main'}
          target="_blank"
          to={'https://search.et.gr/el/fek/?fekId=805318'}
        >
          Β 5574/2026
        </Typography>
      </Typography>

      <Typography variant="body1" gutterBottom textAlign={'justify'}>
        3.{' '}
        <span style={{ textDecoration: 'underline' }}>
          Κοινή Υπουργική Απόφαση
        </span>
        : Καθορισμός των διαδικασιών άντλησης στοιχείων του Μητρώου
        Απασχολούμενων στον Πολιτιστικό και Δημιουργικό Τομέα καθώς και κάθε
        άλλου θέματος της παρ. 2 του άρθρου 123, του ν. 5039/2023.{' '}
        <Typography
          component={Link}
          color={'link.main'}
          target="_blank"
          to={'https://search.et.gr/el/fek/?fekId=780606'}
        >
          ΦΕΚ Β 2025/2025
        </Typography>
      </Typography>
    </Box>
  );
}
